import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isLiveInputPath } from '@/app/routes/liveScreens';
import { useAuthController } from '@/features/auth/controller/auth.controller';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { TAB_BAR_HEIGHT_VAR } from '@/features/native-app/widget/tabBarHeight';
import { COOKIE_BANNER_HEIGHT_VAR } from './CookieBanner';

/**
 * Offline, teams, rosters and matches come from what this device kept (VOL-14):
 * say they may be out of date, or a roster changed elsewhere passes for current.
 */
export function OfflineReadNotice() {
  const { t } = useTranslation('common');
  const online = useOnlineStatus();
  const user = useAuthController((s) => s.user);
  const { pathname } = useLocation();

  // Live capture has its own sync indicator in this corner.
  if (online || !user || isLiveInputPath(pathname)) return null;

  return (
    <div
      className="fixed left-4 z-50 flex max-w-xs items-center gap-2 rounded-lg bg-gray-800 px-3 py-2 text-sm text-white shadow-lg"
      // Above the app's bottom tabs, which it used to cover; the variable only exists while they show.
      style={{ bottom: `calc(var(${TAB_BAR_HEIGHT_VAR}, 0px) + var(${COOKIE_BANNER_HEIGHT_VAR}, 0px) + 1rem)` }}
      role="status"
      aria-live="polite"
    >
      <span className="h-2 w-2 shrink-0 rounded-full bg-gray-400" aria-hidden="true" />
      <span>{t('offlineReads.notice')}</span>
    </div>
  );
}
